import { render, staticRenderFns } from "./QuoteDetail.vue?vue&type=template&id=3210eb10&scoped=true"
import script from "./QuoteDetail.vue?vue&type=script&lang=js"
export * from "./QuoteDetail.vue?vue&type=script&lang=js"
import style0 from "./QuoteDetail.vue?vue&type=style&index=0&id=3210eb10&lang=scss&scoped=true"
import style1 from "./QuoteDetail.vue?vue&type=style&index=1&id=3210eb10&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3210eb10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3210eb10')) {
      api.createRecord('3210eb10', component.options)
    } else {
      api.reload('3210eb10', component.options)
    }
    module.hot.accept("./QuoteDetail.vue?vue&type=template&id=3210eb10&scoped=true", function () {
      api.rerender('3210eb10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/QuoteDetail.vue"
export default component.exports